import React from 'react';
import FormSection from '@components/Contact-Data/FormSection';
import MapSection from '@components/Contact-Data/MapSection';
function Home() {

    return (
        <div className={'FormSection'}>
            <FormSection />
            <MapSection />
        </div>
    )
}

export default Home;
